const AppName = "Potowatomi Kids Zone";
const Language = "Potowatomi";
const Tribe = "Pokagon Band of Potawatomi";
const FirebaseConfig = {
  apiKey: "AIzaSyCi23PufMZEytmEj6Xgz9ENlIH0-Nc5Glo",
  authDomain: "pokagon-9fddf.firebaseapp.com",
  projectId: "pokagon-9fddf",
  storageBucket: "pokagon-9fddf.appspot.com",
  messagingSenderId: "876621097129",
  appId: "1:876621097129:web:f08e2318096313c6c0a1b8",
  measurementId: "G-F794JX5H1H",
};
const FilePath = "https://storage.googleapis.com/pokagon-media/";

const SheetsToPull = [
  { collection: "KZ_AppData", nameToSave: "gameData" },
  { collection: "KZ_GameDescriptions", nameToSave: "gameDescriptions" },
  { collection: "KZ_GameFilterData", nameToSave: "data" },
  { collection: "KZ_GoldStar", nameToSave: "goldStar" },
  { collection: "KZ_PopupWords", nameToSave: "popupWords" },
  { collection: "KZ_uiWords", nameToSave: "uiWords" },
];

const ParamsToFindGame = [ // Double Check for correctenss
  { data: "category", param: "unit" },
  { data: "displayGameName", param: "game-name" },
];

const FeedbackLink = "";
const BottomColor = "rgba(34,104,10,1)";

const config = {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  FilePath,
  SheetsToPull,
  ParamsToFindGame,
  FeedbackLink,
  BottomColor,
};

export default config;

export {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  FilePath,
  SheetsToPull,
  ParamsToFindGame,
  FeedbackLink,
  BottomColor,
};
